
const twoFATypes = {
    showDialogChange: 'SHOW_DIALOG_CHANGE',
};

export default twoFATypes;